import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import UserDataService from '../../../../services/UserDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { ACTIVITY_LOGS_LOADING_STATES, COMMON_EXPORTING_STATES, PAGE_STATE } from '../../constants/constants';
import { componentKey, setActivityLogs, setExportFile, setLoadingState, setSelectedLog, setTotalLogs } from './ActivityLogsSlice';

export const { getActivityLogs, getActivityLogDetails, getActivityLogExportExcel } = {
	getActivityLogs: (payload) => {
		return {
			type: "ACCOUNT/GET_ACTIVITY_LOGS",
			payload: payload
		}
	},
	getActivityLogDetails: (payload) => {
		return {
			type: "ACCOUNT/GET_ACTIVITY_LOG_DETAILS",
			payload: payload
		}
	},
	getActivityLogExportExcel: (payload) => {
		return {
			type: "ACCOUNT/GET_ACTIVITY_LOG_EXPORT_EXCEL",
			payload: payload
		}
	},
}

function* getActivityLogsAsync(action) {
	try {
		const { userName, eventName, skip, rowsPerPage, role, startDate, endDate } = action.payload;

		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.GRID_LOADING, message: "Getting Activity Logs......" }));

		const param =  {PageNumber: (skip / rowsPerPage) + 1, PageSize: rowsPerPage, userName, eventName, role, eventDate: `${startDate} - ${endDate}`}

		const response = yield UserDataService.getActivityLogs(param);

		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.GRID_READY }));
		if (response.data.Status === 0) {

			yield put(addNotifications({
				heading: "Error",
				message: response.data.Data,
				variant: TOASTER_VARIANT.DANGER
			}));
		} else {
			yield put(setActivityLogs(response.data.Data.Data))
			yield put(setTotalLogs(response.data.Data.Total))
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.GRID_READY }))
	}
}

function* getActivityLogDetailsAsync(action) {
	try {
		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.DETAIL_LOADING, message: "Getting Activity Log Details......" }));

		const response = yield UserDataService.getActivityLogDetails(action.payload);

		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.DETAIL_READY }));
		if (response.data.Status === 0) {

			yield put(addNotifications({
				heading: "Error",
				message: response.data.Data,
				variant: TOASTER_VARIANT.DANGER
			}));
		} else {
			yield put(setSelectedLog(response.data.Data))
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: ACTIVITY_LOGS_LOADING_STATES.DETAIL_READY }))
	}
}

function* getActivityLogExportExcelAsync(action) {
	try {
		yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_LOADING, message: "Exporting Activity Log Details......" }));

		const response = yield UserDataService.getActivityLogsExcel({role: action.payload});

		yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_READY }));
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Data,
				variant: TOASTER_VARIANT.DANGER
			}));
		} else {
			yield put(setExportFile(response.data.Data))
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: COMMON_EXPORTING_STATES.EXPORT_READY }))
	}
}


function* rootSaga() {
	yield all([
		takeLatest(getActivityLogs().type, getActivityLogsAsync),
		takeLatest(getActivityLogDetails().type, getActivityLogDetailsAsync),
		takeLatest(getActivityLogExportExcel().type, getActivityLogExportExcelAsync),
	]);
}
store.sagaManager.addSaga(componentKey, rootSaga);